import AthletePage from "../pages/atleta";
import RegistrationProofPage from "../pages/comprovante";
import EscolaModalidadeColetivaPage from "../pages/coletiva";
import Home from "../pages/home";
import IndividualPage from "../pages/individual";
import TechnicalPage from "../pages/tecnico";
export var Routes = {
    "/escola-individual": IndividualPage,
    "/atleta": AthletePage,
    "/comprovante": RegistrationProofPage,
    "/tecnico": TechnicalPage,
    "/escola-coletiva": EscolaModalidadeColetivaPage,
    "/": Home,
};
